export default [{
  test: (prevCard, nextCard) => {
    if (nextCard.startDate && prevCard.startDate && nextCard.startDate < prevCard.startDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_NEXT_START_DATE_BEFORE_PREV_START_DATE',
        relationType: 'sequence',
        prevId: prevCard.id,
        prevDateType: 'startDate',
        prevDate: prevCard.startDate,
        nextId: nextCard.id,
        nextDateType: 'startDate',
        nextDate: nextCard.startDate,
      }
    }
  },
}, {
  test: (prevCard, nextCard) => {
    if (nextCard.startDate && prevCard.dueDate && nextCard.startDate < prevCard.dueDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_NEXT_START_DATE_BEFORE_PREV_DUE_DATE',
        relationType: 'sequence',
        prevId: prevCard.id,
        prevDateType: 'dueDate',
        prevDate: prevCard.dueDate,
        nextId: nextCard.id,
        nextDateType: 'startDate',
        nextDate: nextCard.startDate,
      }
    }
  },
}, {
  test: (prevCard, nextCard) => {
    if (nextCard.dueDate && prevCard.startDate && nextCard.dueDate < prevCard.startDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_NEXT_DUE_DATE_BEFORE_PREV_START_DATE',
        relationType: 'sequence',
        prevId: prevCard.id,
        prevDateType: 'startDate',
        prevDate: prevCard.startDate,
        nextId: nextCard.id,
        nextDateType: 'dueDate',
        nextDate: nextCard.dueDate,
      }
    }
  },
}, {
  test: (prevCard, nextCard) => {
    if (nextCard.dueDate && prevCard.dueDate && nextCard.dueDate < prevCard.dueDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_NEXT_DUE_DATE_BEFORE_PREV_DUE_DATE',
        relationType: 'sequence',
        prevId: prevCard.id,
        prevDateType: 'dueDate',
        prevDate: prevCard.dueDate,
        nextId: nextCard.id,
        nextDateType: 'dueDate',
        nextDate: nextCard.dueDate,
      }
    }
  },
}]
